export function routes(
  $stateProvider,
  $urlRouterProvider,
  $locationProvider
) {
  'ngInject';

  $stateProvider.state('main', {
    // resolve: {
    //   identity(SessionsService) {
    //     console.log('calling session service');
    
    //     return SessionsService.getIdentity();
    //   },
    //   checkNotAuthenticated(AuthorizationService) {
    //     console.log('calling authorization service')
    //     return AuthorizationService.checkNotAuthenticated();
    //   },
    // },
    url: '',
    views: {
      master: {
        controller: 'AppController',
        controllerAs: 'appController',
        template: require('./main/app.html'),
      }
    }
  });
  $stateProvider.state('main.sign_in', {
    resolve: {
      identity(SessionsService) {
        console.log('calling session service');
    
        return SessionsService.getIdentity();
      },
      checkNotAuthenticated(AuthorizationService) {
        console.log('calling authorization service')
        return AuthorizationService.checkNotAuthenticated();
      },
    },
    url: '/sign_in',
    views: {
      'content@main': {
        template: require('./authentication/sign_in.html'),
        controller: 'AuthenticationCtrl',
        controllerAs: 'authenticationCtrl',
      }
    }
  });
  $stateProvider.state('main.signed_out', {
    url: '/signed_out',
    views: {
      'content@main': {
        template: require('./authentication/signed_out.html'),
        controller: 'AuthenticationCtrl',
        controllerAs: 'authenticationCtrl',
      }
    }
  });
  $stateProvider.state('main.sign_out', {
    resolve: {
      identity(SessionsService) {
        return SessionsService.getIdentity();
      },
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    //TODO: wtf?
    url: '/sign_out',
    // templateUrl: 'app/authentication/sign_out.html',
    views: {
      'content@main': {
        template: require('./authentication/sign_out.html'),
        controller: 'AuthenticationCtrl',
        controllerAs: 'authenticationCtrl',
      }
    }
  });
  $stateProvider.state('main.noManagingOrgs', {
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    url: '/no_managing_orgs',
    views: {
      'content@main': {
        template: require('./distributor/no_managing_orgs.html'),
        controller: 'NoManagingOrgsCtrl',
        controllerAs: 'vm'
      }
    }
  });

  $stateProvider.state('main.managing_org_selection', {
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    url: '/managing_org_selection',
    views: {
      'content@main': {
        template: require('./distributor/managing_org_selector.html'),
        controller: 'DistributorSelectorCtrl',
        controllerAs: 'vm',
      }
    }
  });
  $stateProvider.state('main.home', {
    url: '/',
    title: "",
    ncyBreadcrumb: {
      label: 'Skykit Admin-Console',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'WelcomeCtrl',
        controllerAs: 'welcomeCtrl',
        template: require('./welcome/welcome.html'),
      }
    }
  });
  $stateProvider.state('main.welcome', {
    url: '/welcome',
    title: "",
    ncyBreadcrumb: {
      label: 'Skykit Admin-Console',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'WelcomeCtrl',
        controllerAs: 'welcomeCtrl',
        template: require('./welcome/welcome.html'),
      }
    }
  });
  $stateProvider.state('main.domains', {
    url: '/domains',
    title: "Domains",
    ncyBreadcrumb: {
      label: 'Domains',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'DomainsCtrl',
        controllerAs: 'domainsCtrl',
        template: require('./domain/domains-listing.html'),
      }
    }
  });
  $stateProvider.state('main.addDomain', {
    url: '/domains/add',
    title: "Domains",
    ncyBreadcrumb: {
      label: 'Add domain',
      parent: 'main.domains',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'DomainDetailsCtrl',
        controllerAs: 'domainDetailsCtrl',
        template: require('./domain/domain-detail.html'),
      }
    },
  });
  $stateProvider.state('main.editDomain', {
    url: '/domains/:domainId',
    title: "Domains",
    ncyBreadcrumb: {
      label: '{{ domainDetailsCtrl.currentDomain.name }}',
      parent: 'main.domains',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'DomainDetailsCtrl',
        controllerAs: 'domainDetailsCtrl',
        template: require('./domain/domain-detail.html'),
      }
    },
  });
  $stateProvider.state('main.tenants', {
    url: '/tenants',
    title: "Tenants",
    ncyBreadcrumb: {
      label: 'Tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantsCtrl',
        controllerAs: 'tenantsCtrl',
        template: require('./tenant/tenants-listing.html'),
      }
    },
  });
  $stateProvider.state('main.addTenant', {
    url: '/tenants/add',
    title: "Tenants",
    ncyBreadcrumb: {
      label: 'Add tenant',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantAddCtrl',
        controllerAs: 'tenantAddCtrl',
        template: require('./tenant/tenant-add.html'),
      }
    },
  });
  $stateProvider.state('main.tenantDetails', {
    url: '/tenants/:tenantId/details',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.currentTenant.name }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantDetailsCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-details.html'),
      }
    },
  });
  $stateProvider.state('main.tenantManagedDevices', {
    url: '/tenants/:tenantId/managed',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.currentTenant.name }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantManagedDevicesCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-managed-devices.html'),
      }
    },
  });
  $stateProvider.state('main.tenantUnmanagedDevices', {
    url: '/tenants/:tenantId/unmanaged',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.currentTenant.name }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantUnmanagedDevicesCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-unmanaged-devices.html'),
      }
    },
  });
  $stateProvider.state('main.tenantLogs', {
    url: '/tenants/:tenantId/logs',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.currentTenant.name }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantLogsCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-logs.html'),
        
      }
    },
  });
  $stateProvider.state('main.tenantOverlays', {
    url: '/tenants/:tenantId/overlays',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.currentTenant.name }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantOverlaysCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-overlays.html'),
      }
    },
  });
  $stateProvider.state('main.tenantLocations', {
    url: '/tenants/:tenantId/locations',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.currentTenant.name }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantLocationsCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-locations.html'),
      }
    },
  });
  $stateProvider.state('main.tenantProofPlay', {
    url: '/tenants/:tenantId/proofplay',
    title: "Tenants",
    ncyBreadcrumb: {
      label: 'Proof of Play',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'ProofOfPlayCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-proofplay/tenant-proof-play.html'),
      }
    },
  });
  $stateProvider.state('main.editLocation', {
    url: '/locations/:locationId',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.tenantName }}  / {{ vm.locationName }}',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantLocationCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-location.html'),
      }
    },
  });
  $stateProvider.state('main.addLocation', {
    url: '/tenants/:tenantId/location',
    title: "Tenants",
    ncyBreadcrumb: {
      label: '{{ vm.tenantName }}  / Location',
      parent: 'main.tenants',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'TenantLocationCtrl',
        controllerAs: 'vm',
        template: require('./tenant/tenant-location.html'),
      }
    },
  });
  $stateProvider.state('main.devices', {
    url: '/devices',
    title: "Devices",
    ncyBreadcrumb: {
      label: 'Devices',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'DevicesListingCtrl',
        controllerAs: 'devicesListingCtrl',
        template: require('./device/devices-listing.html'),

      }
    },
  });
  $stateProvider.state('main.editDevice', {
    url: '/devices/:deviceId?tenantId?fromDevices',
    title: "Devices",
    ncyBreadcrumb: {
      label: '{{ deviceDetailsCtrl.currentDevice.key }}',
      parent: 'main.devices',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'DeviceDetailsCtrl',
        controllerAs: 'deviceDetailsCtrl',
        template: require('./device/device-detail.html'),
        function($scope, $stateParams) {
          $scope.deviceId = $stateParams.deviceId;
          $scope.tenantId = $stateParams.tenantId;
          return;
        },
      }
    },
  });
  // $stateProvider.state('main.proof', {
  //   url: '/proof',
  //   resolve: {
  //     checkAuthenticated(AuthorizationService) {
  //       return AuthorizationService.checkAuthenticated();
  //     },
  //   },
  //   views: {
  //     'content@main': {
  //       controller: 'ProofOfPlayCtrl',
  //       controllerAs: 'vm',
  //       template: require('./proof/'),
  //       ncyBreadcrumb: {
  //         label: 'Proof of Play',
  //       },
  //     }
  //   },
  // });
  $stateProvider.state('main.reports', {
    url: '/reports',
    title: "Reports",
    ncyBreadcrumb: {
      label: 'Reports',
    },
    resolve: {
      checkAuthenticated(AuthorizationService) {
        return AuthorizationService.checkAuthenticated();
      },
    },
    views: {
      'content@main': {
        controller: 'ReportsCtrl',
        controllerAs: 'reportsCtrl',
        template: require('./reports/reports-list.html'),

      }
    },
  });
  // $stateProvider.state('main.proofDetail', {
  //   url: '/proof/:tenant',
  //   resolve: {
  //     checkAuthenticated(AuthorizationService) {
  //       return AuthorizationService.checkAuthenticated();
  //     },
  //   },
  //   views: {
  //     'content@main': {
  //       controller: 'ProofOfPlayCtrl',
  //       controllerAs: 'vm',
  //       template: require('./proof/detail.html'),
  //       ncyBreadcrumb: {
  //         label: 'Proof of Play',
  //       },
  //     }
  //   },
  // });
  $stateProvider.state('main.admin', {
    url: '/admin',
    title: "Admin",
    ncyBreadcrumb: {
      label: 'Admin',
    },
    resolve: {
      isAdmin(AuthorizationService) {
        return AuthorizationService.checkIsOrgAdmin();
      },
    },
    views: {
      'content@main': {
        controller: 'AdminCtrl',
        controllerAs: 'vm',
        template: require('./admin/admin.html'),
      }
    },
  });
  $stateProvider.state('main.redirect', {
    url: '/redirect',
    ncyBreadcrumb: {
      label: 'Redirect',
    },
    views: {
      'content@main': {
        controller: 'RedirectCtrl',
        controllerAs: 'vm',
        template: require('./redirect/redirect.html'),
      }
    }
  });

  // $urlRouterProvider.otherwise('/sign_in');
  $urlRouterProvider.otherwise('');
  $locationProvider.hashPrefix('');
}

routes.$inject = [
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider'
];
